import { Component, EventEmitter, forwardRef, Input, Output, ViewChild } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Ui2DatePickerModel, Ui2DatePickerType, Ui2QuickSelectOption } from '../models/date-picker.model';
import { Ui2DatepickerQuickOptionsComponent } from './ui2-datepicker-quick-options/ui2-datepicker-quick-options.component';

const VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => Ui2DatepickerComponent),
  multi: true
};

@Component({
  selector: 'ui2-datepicker',
  templateUrl: './ui2-datepicker.component.html',
  styleUrls: ['./ui2-datepicker.component.scss', './../styles/material.scss'],
  providers: [VALUE_ACCESSOR]
})
export class Ui2DatepickerComponent implements ControlValueAccessor {
  // public the enum
  public ui2DatePickerType = Ui2DatePickerType;

  @Input()
  public datePickerType: Ui2DatePickerType;

  @Input()
  public disabled: boolean;

  @Input()
  public required: boolean;

  @Input()
  public clearable: boolean = true;

  @Input()
  public readonly: boolean;

  @Input()
  public styled: boolean;

  @Input()
  public quickOptions: Array<Ui2QuickSelectOption>;

  @Input()
  public placeholder: string;

  @Input()
  public customClass: string = '';

  public localValue: Ui2DatePickerModel | Ui2QuickSelectOption;

  @Output()
  public focusChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  /**
   * Reference to quick option panel component.
   */
  @ViewChild('quickOptionPanel')
  public quickOptionPanelTemplate: Ui2DatepickerQuickOptionsComponent;

  set model(value: Ui2DatePickerModel | Ui2QuickSelectOption) {
    if (this.checkFalseChange(value)) {
      return;
    }

    this.localValue = value;
  }

  public onChange: (list: Ui2DatePickerModel | Ui2QuickSelectOption) => void = () => {};
  public onTouch: (list: Ui2DatePickerModel | Ui2QuickSelectOption) => void = () => {};

  public writeValue(value: Ui2DatePickerModel | Ui2QuickSelectOption): void {
    this.model = value;
  }

  public registerOnChange(fn: () => void): void {
    this.onChange = fn;
  }

  public registerOnTouched(fn: () => void): void {
    this.onTouch = fn;
  }

  public selectionChange(value) {
    if (this.checkFalseChange(value)) {
      return;
    }

    setTimeout(() => {
      this.localValue = value;
      this.onChange(this.localValue);
      this.onTouch(this.localValue);
    }, 0);
  }

  private checkFalseChange(value): boolean {
    const falseChange = (this.localValue === undefined || this.localValue === null) && (value === undefined || value === null);

    return falseChange;
  }

  /**
   * Toggle quick option drop down panel.
   */
  public openQuickOptionDropdown(event: any): void {
    // Stop event to bubble up.
    event.stopPropagation();

    // Only if dropdown is no opened.
    if (!this.quickOptionPanelTemplate.openDropdown) {
      this.quickOptionPanelTemplate.toggleDropdown();
    }
  }
}
